<template>
  <v-container>

    <v-card>
      <v-toolbar flat color="blue accent-2" class="white--text">
        <v-btn to="/" icon text>
          <v-icon small class="white--text">mdi-home</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h3 class="font-weight-light">Anuncios directorio</h3>
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <loader v-if="isloading"></loader>

        <v-row dense>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="items" disable-pagination hide-default-footer item-key="key" class="elevation-1 mt-6">

              <template v-slot:item.image="{ item }">
                <img class="mt-2 mb-2" height="50" width="50" :src="`${$awsPath}/${item.image[0]}`" alt="">
              </template>

              <template v-slot:item.usuario="{ item }">
                <pre>{{item.userId.name}}</pre>
              </template>

              <template v-slot:item.email="{ item }">
                <pre>{{item.userId.email}}</pre>
              </template>

              <template v-slot:item.action="{ item }">


              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>


  </v-container>
</template>

<script>
  import {
    directorio_service
  } from '~/directorio_service'

  export default {

    data() {
      return {
        items: [],

        item: {},

        headers: [{
            text: 'Imagen',
            value: 'image',
            width: 90,
          }, {
            text: 'Usuario',
            value: 'usuario',
          },
          {
            text: 'Email',
            value: 'email',
          },
          {
            text: 'Titulo',
            value: 'title',
          },
          {
            text: 'Acciones',
            value: 'action',
            sortable: false
          },
        ],
      }
    },

    created() {
      this.getAdverts()
    },

    methods: {
      getAdverts(role) {
        directorio_service.get_all_anuncios().then(res => {
          this.items = res.data
        }, res => {
          this.$toast.error('Error consultando adverts')
        })
      }
    },
    computed: {
      isloading() {
        return this.$store.getters.getloading
      },
      errors() {
        return this.$store.getters.geterrors
      },
      user() {
        return JSON.parse(localStorage.getItem('user'))
      },
    }
  }
</script>